import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycStartedPage from './KycStartedPage';

const KycStartedRoute: FuseRouteItemType = {
  path: '',
  element: <KycStartedPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycStartedRoute;
